import type { IconProps } from '../../../components/Icon/Icon.util';
export const LoadingSpinner = ({
  width = 32,
  height = 32,
  stroke = '#121923',
  strokeWidth = 1.2,
  className
}: IconProps): React.ReactNode => {
  return <svg className={className} fill='none' height={height} viewBox='0 0 25 25' width={width} xmlns='http://www.w3.org/2000/svg' data-sentry-element="svg" data-sentry-component="LoadingSpinner" data-sentry-source-file="LoadingSpinner.tsx">
      <path d='M4.5 12.5C4.5 16.9183 8.08172 20.5 12.5 20.5C16.9183 20.5 20.5 16.9183 20.5 12.5C20.5 8.08172 16.9183 4.5 12.5 4.5' stroke={stroke} strokeWidth={strokeWidth} data-sentry-element="path" data-sentry-source-file="LoadingSpinner.tsx" />
    </svg>;
};